import { render } from "./Fridges.vue?vue&type=template&id=28fa4860&scoped=true"
import script from "./Fridges.vue?vue&type=script&lang=js"
export * from "./Fridges.vue?vue&type=script&lang=js"

import "./Fridges.vue?vue&type=style&index=0&id=28fa4860&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fa4860"]])

export default __exports__